/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardsAccountRecalculatePointsRequest
 */
export interface RewardsAccountRecalculatePointsRequest {
    /**
     * 
     * @type {number}
     * @memberof RewardsAccountRecalculatePointsRequest
     */
    courierId: number;
}

/**
 * Check if a given object implements the RewardsAccountRecalculatePointsRequest interface.
 */
export function instanceOfRewardsAccountRecalculatePointsRequest(value: object): value is RewardsAccountRecalculatePointsRequest {
    if (!('courierId' in value) || value['courierId'] === undefined) return false;
    return true;
}

export function RewardsAccountRecalculatePointsRequestFromJSON(json: any): RewardsAccountRecalculatePointsRequest {
    return RewardsAccountRecalculatePointsRequestFromJSONTyped(json, false);
}

export function RewardsAccountRecalculatePointsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardsAccountRecalculatePointsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'],
    };
}

export function RewardsAccountRecalculatePointsRequestToJSON(json: any): RewardsAccountRecalculatePointsRequest {
    return RewardsAccountRecalculatePointsRequestToJSONTyped(json, false);
}

export function RewardsAccountRecalculatePointsRequestToJSONTyped(value?: RewardsAccountRecalculatePointsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
    };
}

